import { useState, useEffect } from "react";
import { usePatientContext } from "Context/Patient";
import {
  GetPatientDocuments,
  PostPatientFiles,
} from "Services/API/Patients.service";
import UploadOtherFiles from "Components/Common/UploadOtherFiles/UploadOtherFiles";
import { UploadFile } from "Components/Common/UploadFile/UploadFile";
import {
  None,
  Section,
} from "Components/Patients/EditViewPatient/Forms/DetailSection/DetailSection";
import "Components/Patients/EditViewPatient/Forms/FormCommonCss/Form.css";
import { Divider } from "Components/Common/Divider/Divider";

export const UploadFiles = ({ setActiveTabIndex }) => {
  const { getPatientData } = usePatientContext();
  const { id } = getPatientData() || {};
  const [files, setFiles] = useState([
    { key: 1, id: "", url: "", fileName: "" },
  ]);
  const [previousDocs, setPreviousDocs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [count, setCount] = useState(1);

  const GetUserDocs = () => {
    GetPatientDocuments(id)
      .then((res) => {
        setPreviousDocs(res);
      })
      .catch((err) => {
        console.log("[GetPatientDocuments][API_ERROR] - ", err);
      });
  };
  useEffect(() => {
    if (id) {
      GetUserDocs();
    }
  }, []);
  return (
    <>
      <div className="flex flex-col gap-4 FormWrapper">
        {/* Existing documents and the uploader are two different things —
            carding them apart stops a new upload row from reading as another
            stored file. */}
        <Section title={`Files on record${previousDocs?.length ? ` (${previousDocs.length})` : ""}`} columns={1}>
          {previousDocs?.length ? (
            previousDocs.map((doc) => (
              <div className="flex flex-col gap-2" key={doc?.id ?? doc?.name}>
                <UploadFile mode="View" value={doc?.url} label={doc.name} />
              </div>
            ))
          ) : (
            <None />
          )}
        </Section>

        <Section title="Add files" columns={1}>
        {files.map((file, index) => {
          return (
            <div className="pb-4" key={count + index}>
              <UploadOtherFiles
                key={index}
                id={file.key}
                files={files}
                fileUrl={file.url}
                setFiles={setFiles}
                isLoading={isLoading}
                fileName={file.fileName}
                setIsLoading={setIsLoading}
                title="File upload"
                placeHolder="Title"
                onResponseFileAdd={({ data }, value) => {
                  if (data) {
                    PostPatientFiles(id, {
                      otherDocuments: [
                        ...previousDocs.map((doc) => doc.id),
                        data,
                      ],
                    })
                      .then((res) => {
                        if (res) {
                          let submittedFile = files.filter(
                            (file) => file.key !== value
                          );
                          setFiles([...submittedFile]);
                          setIsLoading(false);
                          GetUserDocs();
                        }
                      })
                      .catch((err) => {
                        console.log("[PostPatientFiles][API_ERROR] -  ", err);
                        setIsLoading(false);
                      });
                  }
                }}
                handleCancelFile={(value) => {
                  let cancelFile = files.filter((file) => file.key !== value);
                  setFiles([...cancelFile]);
                }}
              />
            </div>
          );
        })}
          <Divider
            onClick={() => {
              setCount(count + 1);
              setFiles([
                ...files,
                { key: count + 1, id: "", url: "", fileName: "" },
              ]);
              // setIsDisabled(true);
            }}
            isDisabled={false}
          />
        </Section>
      </div>
    </>
  );
};
